const _excluded = ["option", "highlighted", "selected", "label", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { ListItemLayout } from "../ListItemLayout";
export const Option = /*#__PURE__*/React.forwardRef(function OptionComponent(_ref, ref) {
  let {
      option,
      highlighted,
      selected,
      label,
      size = "md"
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("li", _extends({
    ref: ref
  }, rest, {
    "data-value": option.value
  }), /*#__PURE__*/React.createElement(ListItemLayout, {
    primary: label,
    selected: selected,
    secondary: option.secondary,
    disabled: option.disabled,
    selectionMode: "solo-checkmark",
    variant: size === "sm" ? "sm" : "base",
    highlighted: highlighted
  }));
});
export function renderOptionDefault(props) {
  return /*#__PURE__*/React.createElement(Option, props);
}
export function getOptionLabelDefault(option) {
  if (!option) {
    return "";
  }
  if (option.title === undefined) {
    return String(option.value ?? "");
  }
  if (typeof option.title === "function") {
    return option.title();
  }
  return option.title;
}